/**
 * API address configuration file
 */

/**Get the configuration URL for all APIs*/
var cpdfadminURI = window.location.protocol + '//' + window.location.host
if (cpdfadminURI.indexOf('http://localhost') !== -1) {
    cpdfadminURI = 'https://pheeadmin-docker.connectedpdf.com'
}

// API endpoints
export const GET_SERVER_CONFIG = cpdfadminURI + '/api/server-config';
export const SIGNUP = cpdfadminURI + '/api/site/sign-up';
export const SIGNIN = cpdfadminURI + '/api/site/signin';
export const LOGIN = cpdfadminURI + '/api/site/login';
export const ADMIN_USER_INFO = cpdfadminURI + '/api/admin/user-info';
export const LOGOUT = cpdfadminURI + '/api/site/logout';
export const GET_TENANTS_DATA = cpdfadminURI + '/api/site/tenants-data';
export const SITE_RELEASE_LOG = cpdfadminURI + '/api/site/release-log';
export const SITE_DELETE_USER = cpdfadminURI + '/api/site/delete-user';
export const GET_PUT_SITE_CONFIG_SUPPORT = cpdfadminURI + '/api/site-config/support';
export const GA_TO_SUBSCRIPTION = cpdfadminURI + '/api/site-config/ga-to-subscription';
export const GET_ADMIN_LIST = cpdfadminURI + '/api/admin/list';
export const PUT_DISABLE_ADMIN = cpdfadminURI + '/api/admin/disable';
export const PUT_ENABLE_ADMIN = cpdfadminURI + '/api/admin/enable';
export const GET_ROLE_LIST = cpdfadminURI + '/api/role/list';
export const DEL_ROLE_LIST = cpdfadminURI + '/api/role';
export const GET_RESOURCE_LIST = cpdfadminURI + '/api/resource/list';
export const POST_CREATE_ADMIN = cpdfadminURI + '/api/admin/create';
export const API_ADMIN = cpdfadminURI + '/api/admin';
export const GET_POLICY_LIST = cpdfadminURI + '/api/policy/list';
export const POST_CREATE_ROLE = cpdfadminURI + '/api/role/create';
export const GET_ADMIN_LOG_LIST = cpdfadminURI + '/api/admin-log/list';
export const SITE_SSO_LOGIN = cpdfadminURI + '/api/site/sso-login';
export const SITE_ROLE_ADMIN_ROLES = cpdfadminURI + '/api/role/admin-roles';
export const GET_COUNTRY_LIST = cpdfadminURI + '/api/common/country';
export const CHANGE_USER_REGION = cpdfadminURI + '/api/user/change-region';
export const GET_USER_INFO = cpdfadminURI + '/api/user/info';
export const UPDATE_USER_COUNTRY = cpdfadminURI + '/api/user';